import {ModalDialog} from 'mc/lib/modal';
import PropTypes from 'prop-types';
import React from 'react';
import {Provider} from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
import {browserHistory, Router} from 'react-router';
import routes from './routes';

const Root = ({store}) => (
    <Provider store={store}>
        <div>
            <Router history={browserHistory} routes={routes}/>
            <ReduxToastr/>
            <ModalDialog/>
        </div>
    </Provider>
);

Root.propTypes = {
    store: PropTypes.object.isRequired
};

export default Root;
